import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { getVersionClear } from './Localstorage/localstorage';

getVersionClear();

// App-wide theme bootstrap:
// - localStorage `rp-theme` supports: "dark" | "light" | "auto"
// - auto uses schedule: light 06:00-18:59, dark otherwise
const THEME_STORAGE_KEY = "rp-theme";
const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
const hour = new Date().getHours();
const isAutoDark = !(hour >= 6 && hour < 19);
const resolvedTheme = savedTheme || "auto";
const isDark =
  resolvedTheme === "dark"
    ? true
    : resolvedTheme === "light"
    ? false
    : isAutoDark;

document.documentElement.classList.toggle("dark", isDark);
document.documentElement.style.colorScheme = isDark ? "dark" : "light";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Removed React.StrictMode to avoid double-invoking renders and effects in development
  <App />
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
